import { defineStore } from 'pinia'
import { isUnifiedCommerce } from '@shared/constants'
import { checkPermissions } from '@shared/utils/permissions'
import { useAuthStore } from '@shared/store/auth'
import th from '@tillhub/javascript-sdk'

export const useBranchesStore = defineStore('branches', {
  state: () => ({
    branchesCount: 1
  }),
  actions: {
    async checkBranchesCount() {
      const authStore = useAuthStore()
      if (
        !isUnifiedCommerce() ||
        checkPermissions(
          { scopes: ['resources:branches:read'] },
          authStore.role,
          authStore.scopes
        )
      ) {
        try {
          const { data } = await th
            .branchesV1()
            .meta({ query: { deleted: false } })
          this.branchesCount = data?.count || 0
        } catch (err) {
          this.$logException(err, { trackError: false })
          this.branchesCount = 1
        }
      }
    }
  }
})
